import * as React from 'react'
import styled from 'styled-components'

import { EuroCents, toCurrency } from '@espoon-voltti/ts-libs/lib/euro'

import {
  Columns,
  Column,
  Title
} from '@espoon-voltti/react-components/elements'
import { LabelValueListItem } from '@espoon-voltti/react-components/components'
import { LabelValueList } from '@espoon-voltti/react-voltti/components/label-value-list'

import { Transaction } from '@espoon-voltti/nuora-domain/grants'

import { t } from '../../../i18n'

interface Props {
  expenses: Transaction[]
  incomes: Transaction[]
}

const Spacer = styled.div`
  margin-top: 10px;
`

export const ExpensesAndIncomes = ({ expenses, incomes }: Props) => {
  const expenseRows = expenses.map((x) => ({
    label: x.description,
    value: toCurrency(x.amount),
    dataQa: 'transaction'
  }))
  const expenseTotal = totalSum(expenses)
  const incomeRows = incomes.map((x) => ({
    label: x.description,
    value: toCurrency(x.amount),
    dataQa: 'transaction'
  }))
  const incomeTotal = totalSum(incomes)

  return (
    <Columns dataQa={'expensesAndIncomes'}>
      <Column>
        <Columns>
          <Column>
            <Spacer />
            <Title dataQa={'expensesTitle'} size={4}>
              {t([
                'views',
                'preview',
                'expensesAndIncomes',
                'expenses',
                'title'
              ])}
            </Title>
            <LabelValueList values={expenseRows} dataQa={'expenses'} />
            <Spacer />
            <LabelValueListItem
              label={t([
                'views',
                'preview',
                'expensesAndIncomes',
                'expenses',
                'total'
              ])}
              value={<strong>{toCurrency(expenseTotal)}</strong>}
              dataQa={'expensesTotalSum'}
            />
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Spacer />
            <Title dataQa={'incomesTitle'} size={4}>
              {t([
                'views',
                'preview',
                'expensesAndIncomes',
                'incomes',
                'title'
              ])}
            </Title>
            <LabelValueList values={incomeRows} dataQa={'incomes'} />
            <Spacer />
            <LabelValueListItem
              label={t([
                'views',
                'preview',
                'expensesAndIncomes',
                'incomes',
                'total'
              ])}
              value={<strong>{toCurrency(incomeTotal)}</strong>}
              dataQa={'incomesTotalSum'}
            />
          </Column>
        </Columns>
      </Column>
    </Columns>
  )
}

const totalSum = (rows: Transaction[]) =>
  rows.reduce((sum, row) => sum.plus(row.amount), EuroCents.zero())
